import { AssessmentCollectionLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";
const Forms = [
  {
    fileStoreId: "18018526-2a59-4f3c-8a94-891f18042026",
    label: "Exemption Form",
  },
  {
    fileStoreId: "18018626-2a59-4f3c-8a94-891f18042026",
    label: "Form No.A-75 when tenant - lessee moves in",
  },
  {
    fileStoreId: "e6456561-c83d-49ce-940c-7df9838c1e8a",
    label:
      "Form No.A-42 Application for Entry of Names in the Assessment Register U/S 183 and Separation/Amalgamation of numbers(s) U/S 178(4) and Apportionment U/S 178-2--II- Proviso of the Kolkata Municipal Act, 1980.]",
  },
  {
    fileStoreId: "18018826-2a59-4f3c-8a94-891f18042026",
    label: "Form No. A - 75 when tenant - lessee moves out",
  },
  {
    fileStoreId: "18018926-2a59-4f3c-8a94-891f18042026",
    label: "SAF Form",
  },
  {
    fileStoreId: "18019026-2a59-4f3c-8a94-891f18042026",
    label: "Property Information Form",
  },
];

const Assessment_collection_download_forms = () => (
  <TableStructure
    title="Download Forms"
    heading={"Forms List"}
    list={Forms}
    leftMenuList={AssessmentCollectionLeftMenuList}
  />
);

export default Assessment_collection_download_forms;
